import React from 'react'

import HeaderTitle from '_/components/header-title'

import useStyles from './styles'
import { CancelButton, EditButton } from '_views/budget-view-v2/components/Header/buttons'
import { SendButton } from './Buttons'

import { useParams, navigate } from '@reach/router'
import { useSelector } from 'react-redux'
import { getBudgetByIdSelectorJS } from '_/modules/budget/selectors'
import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'

import { Loader } from '@refera/ui-web'
import useRolePermission from '_/hooks/use-role-permission'
import { ROUTES } from '_/utils/constants'

export function Header() {
  const styles = useStyles()
  const { serviceOrderId, budgetId } = useParams()
  const budget = useSelector(getBudgetByIdSelectorJS(budgetId))
  const { loading } = useBudgetForm()
  const { isTradesman } = useRolePermission()

  const renderTitle = () => {
    if (budgetId) {
      const title = `Orçamento n.º ${budgetId}`
      return budget?.isOriginal ? `${title} - Original` : title
    }

    return 'Novo Orçamento'
  }

  const handleBack = () => {
    const shouldGoToOldBudgetScreen =
      (budget?.proposeOpened && budget?.diagnosis) || budget?.released
    let url = `/chamado/${serviceOrderId}${
      shouldGoToOldBudgetScreen ? `/orcamento/${budgetId}` : ''
    }`

    if (isTradesman) url = `${ROUTES.DETAIL_SERVICE_ORDER}/${serviceOrderId}`

    navigate(url)
  }

  return (
    <HeaderTitle title={renderTitle()} backButtonAction={handleBack}>
      <div className={styles.headerButtonsContainer}>
        <EditButton />
        <SendButton />
        <CancelButton />
      </div>
      <Loader open={loading} hasBackdrop />
    </HeaderTitle>
  )
}
